import { isString } from 'lodash';

class UtilsService {
    removeSpaces(value) {
        return isString(value) ? value.trim().replace(/ /g, '') : '';
    }

    removeHyphens(value) {
        return isString(value) ? value.trim().replace(/-|\s/g, '') : '';
    }

    formatPhoneNumber(value) {
        return isString(value) ? this.removeSpaces(value).replace(/[()-]|(\+1)/g, '') : '';
    }

    formatPostalCode(value, country = 'ca') {
        if (!isString(value)) {
            return '';
        }

        if (country === 'us') {
            const trimValue = this.removeHyphens(value);
            const zipCodeFirstPart = trimValue.substring(0, 5).toUpperCase();
            const zipCodeLastPart = trimValue.substring(5, 9).toUpperCase();
            const zipCode = `${zipCodeFirstPart}-${zipCodeLastPart}`;
            return trimValue.length > 5 ? zipCode : this.removeHyphens(zipCode);
        }

        const trimValue = this.removeSpaces(value);
        const postalCodeFirstPart = trimValue.substring(0, 3).toUpperCase();
        const postalCodeLastPart = trimValue.substring(3, 6).toUpperCase();
        const postalCode = `${postalCodeFirstPart} ${postalCodeLastPart}`;
        return trimValue.length > 3 ? postalCode : this.removeSpaces(postalCode);
    }
}

export default new UtilsService();
